'use client'
import Image from 'next/image'
import SelectDropDown from './selectDropDown'
import { usePageNumberUpdator } from '@/app/hooks/usePageParamUpdater'

export default function SearchResultSort({
  options,
  selectedOption,
  sortByFunction,
  order,
  orderByFunction,
}: {
  options: string
  selectedOption: string
  sortByFunction: (value: string) => void
  order: string
  orderByFunction: (value: string) => void
}) {
  const goToPage = usePageNumberUpdator()

  return (
    <div className=" flex flex-row  items-center justify-center mobile:mt-3">
      <SelectDropDown
        filterSort={options}
        order={selectedOption}
        setOrder={sortByFunction}
      />
      <span className="flex items-center justify-center border border-solid border-[#e0e0e0] ml-[5px] p-2 h-[40px]">
        {order == 'desc' ? (
          <Image
            alt="desc"
            src="/assets/Icons/sortDownIcon.svg"
            height={19}
            width={19}
            onClick={() => {
              orderByFunction('asc')
              goToPage({ newPageNo: 1 })
            }}
          />
        ) : (
          <Image
            alt="asc"
            src="/assets/Icons/sortUpIcon.svg"
            height={19}
            width={19}
            onClick={() => {
              orderByFunction('desc')
              goToPage({ newPageNo: 1 })
            }}
          />
        )}
      </span>
    </div>
  )
}
